module.exports = __webpack_public_path__ + "static/img/008.16f34c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/008.jpg
// module id = kNuw
// module chunks = 1